/**
 *  Created by 欧盟 on 2019-04-23.
 */
let routes = [
    { // 采购列表
        path: '/purchase/list',
        name: 'purchase-list',
        meta: {
            title: '采购列表',
            company: true
        },
        component: () => import('../views/purchase/list')
    },
    { // 采购详情
        path: '/purchase/detail',
        name: 'purchase-detail',
        meta: {
            title: '采购详情',
            company: true
        },
        component: () => import('../views/purchase/detail')
    },
    { // 购物车列表
        path: '/purchase/shopCart/shopCart',
        name: 'shopCart-list',
        meta: {
            title: '购物车列表',
            company: true
        },
        component: () => import('../views/purchase/shopCart/shopCart')
    },
    { // 商品切换列表
        path: '/purchase/shopCart/shopChangeList',
        name: 'shopChangeList-list',
        meta: {
            title: '购物车列表',
            company: true
        },
        component: () => import('../views/purchase/shopCart/shopChangeList')
    }
];
export default routes;
